"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ad_hok_1 = require("ad-hok");
var addPropTrackingRef = function (propName, refPropName) {
    return ad_hok_1.flowMax(ad_hok_1.addRef(refPropName, null), ad_hok_1.addEffect(function (_a) {
        var _b = propName, propValue = _a[_b], _c = refPropName, ref = _a[_c];
        return function () {
            ref.current = propValue;
        };
    }, [propName]));
};
exports.default = addPropTrackingRef;
